import { SelectInput, SelectInputItem } from '@ads/components-react';
import { useTranslation } from 'react-i18next';

import type { ActiveLanguage } from '../../../store/atoms/editorUiAtom';

export interface LanguageSelectorProps {
  readonly activeLanguage: ActiveLanguage;
  readonly onLanguageChange: (lang: ActiveLanguage) => void;
  readonly isTranslating?: boolean;
  readonly completeness?: Partial<Record<ActiveLanguage, boolean>>;
}

type LangLabelKey = 'topBar.languagePtBr' | 'topBar.languageEn' | 'topBar.languageEs';

const LANGUAGES: { key: ActiveLanguage; labelKey: LangLabelKey }[] = [
  { key: 'pt-BR', labelKey: 'topBar.languagePtBr' },
  { key: 'en-US', labelKey: 'topBar.languageEn' },
  { key: 'es-ES', labelKey: 'topBar.languageEs' },
];

export function LanguageSelector({
  activeLanguage,
  onLanguageChange,
  isTranslating,
  completeness,
}: LanguageSelectorProps) {
  const { t } = useTranslation('slideEditor');

  const isDisabled = (completeness?.[activeLanguage] ?? false) && (isTranslating ?? false);

  return (
    <SelectInput
      value={activeLanguage}
      onValueChange={value => onLanguageChange(value as ActiveLanguage)}
      disabled={isDisabled}
      size="md"
    >
      {LANGUAGES.map(({ key, labelKey }) => (
        <SelectInputItem custom={{ root: 'text-nowrap' }} key={key} value={key}>
          {t(labelKey)}
        </SelectInputItem>
      ))}
    </SelectInput>
  );
}
